import { render, staticRenderFns } from "./VxBreadcrumb.vue?vue&type=template&id=5d02e88f&"
import script from "./VxBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./VxBreadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d02e88f')) {
      api.createRecord('5d02e88f', component.options)
    } else {
      api.reload('5d02e88f', component.options)
    }
    module.hot.accept("./VxBreadcrumb.vue?vue&type=template&id=5d02e88f&", function () {
      api.rerender('5d02e88f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/VxBreadcrumb.vue"
export default component.exports